import React, { useState } from "react";
import { Button, Dropdown, Menu } from "antd";
import { MAX_WIDTH_IPAD_PRO, ROUTER_PATH } from "../../common/constant";
import { getSlugByLanguage, localizeRouteKey } from "../../shared/helpers";
import { useTranslation } from "react-i18next";
import queryString from "query-string";
import _ from "lodash";
import { Link } from "react-router-dom";
import { ISectionCSS } from "../../models/interface/ISectionCSS";
import { RightOutlined } from "@ant-design/icons";

const HomeCategoryItem = (props: any) => {
  const { category, location, slug, history } = props;
  const { t, i18n } = useTranslation();
  const { innerWidth } = window;
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [lastClick, setLastClick] = useState(0);
  const [watingClick, setWatingClick] = useState<any>(null);

  const triggerValue: any =
    innerWidth > MAX_WIDTH_IPAD_PRO ? ["hover"] : ["click"];

  const iconUrl: ISectionCSS = {
    "--icon": `url("${category.icon}")` || "",
  };

  const getRoute = (
    type: string,
    slug: string = "",
    hasChild: boolean = true
  ) => {
    if (!hasChild) {
      return localizeRouteKey(`routes.${type}`);
    } else {
      return (
        localizeRouteKey(ROUTER_PATH.CATEGORY) +
        t(`routes.category_${type}`) +
        `${slug && slug !== type ? `?${t("detail_query")}=${slug}` : ""}`
      );
    }
  };

  const getParentSlug = (catParent: any, catChild: any) => {
    //San pham may khac phai hard code vi khong cung category cha
    if (
      [
        t("routes.category_ruot-men"),
        t("routes.category_ao-goi"),
        t("routes.category_tam-an-toan-ve-sinh-nem"),
        // t("routes.category_vo-boc-nem"),
      ].includes(`/${catChild.slug}`)
    ) {
      return catChild.slug;
    }

    return catParent?.category_ids?.length ? catParent?.slug : catChild.slug;
  };

  const getChildrenId = (catParent: any, catChild: any) => {
    //San pham may khac phai hard code vi khong cung category cha
    if (
      [
        t("routes.category_ruot-men"),
        t("routes.category_ao-goi"),
        t("routes.category_tam-an-toan-ve-sinh-nem"),
        // t("routes.category_vo-boc-nem"),
      ].includes(`/${catChild.slug}`)
    ) {
      return "";
    }

    return catParent?.category_ids?.length
      ? getSlugByLanguage(catChild, i18n.language)
      : "";
  };

  const checkActive = (cat: any, query: string) => {
    if (cat.slug === slug.split("/")[1] && !query) {
      return true;
    }

    if (!query) {
      return false;
    }

    const parseQuery = queryString.parse(query);

    if (cat.header_ids && cat.header_ids.length) {
      const temp = cat.header_ids.filter(
        (item: any) =>
          item.slug === parseQuery[t("detail_query")] ||
          item.slug_en === parseQuery[t("detail_query")]
      );

      if (temp && temp.length) {
        return true;
      }
    }

    if (!parseQuery || !parseQuery[t("detail_query")]) {
      return false;
    }

    if (
      parseQuery[t("detail_query")] !== getSlugByLanguage(cat, i18n.language)
    ) {
      return false;
    }

    return true;
  };

  const showMenuItems = () =>
    category.header_ids &&
    category.header_ids.length &&
    _.sortBy(category.header_ids, ["order"])
      .filter((item: any) => item.is_actived)
      .map((c: any) => showMenuItem(c));

  const showMenuItem = (item: any) => (
    <Menu.Item key={item._id} className={`category-menu-item `}>
      {item.header_ids.length ? (
        <div className="category-sub-menu">
          <a
            onClick={(e) => {
              const elSubMenuItems = document.querySelector(
                ".category-sub-menu-items"
              );
              const elSubMenuIcon = document.querySelector(
                ".category-sub-menu-title-icon"
              );
              if (elSubMenuItems && elSubMenuIcon) {
                elSubMenuItems.classList.toggle("sub-menu-item-collapsed");
                elSubMenuIcon.classList.toggle("sub-menu-icon-collapsed");
              }

              //handle double click
              if (lastClick && e.timeStamp - lastClick < 250 && watingClick) {
                history.push(localizeRouteKey(ROUTER_PATH.SPECIAL_MATTRESS));
                setLastClick(0);
                clearTimeout(watingClick);
                setWatingClick(null);
              } else {
                setLastClick(e.timeStamp);
                setWatingClick(
                  setTimeout(() => {
                    setWatingClick(null);
                  }, 251)
                );
              }
            }}
            className={`category-sub-menu-title ${
              checkActive(item, location.search)
                ? "category-menu-item-active"
                : ""
            }`}>
            <span>{item.name}</span>
            <span className="category-sub-menu-title-icon">
              <RightOutlined style={{ fontSize: 12 }} />
            </span>
          </a>
          <ul className="category-sub-menu-items">
            {_.sortBy(item.header_ids, ["order"]).map((h: any) => (
              <li key={h._id}>
                <Link
                  className={
                    checkActive(h, location.search)
                      ? "category-menu-item-active"
                      : ""
                  }
                  onClick={() => setIsVisible(false)}
                  to={getRoute(
                    getParentSlug(category, h),
                    getChildrenId(category, h)
                  )}>
                  <span title={h.name}>{h.name}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <Link
          className={
            checkActive(item, location.search)
              ? "category-menu-item-active"
              : ""
          }
          onClick={() => setIsVisible(false)}
          to={getRoute(
            getParentSlug(category, item),
            getChildrenId(category, item)
          )}>
          <span title={item.name}>{item.name}</span>
        </Link>
      )}
    </Menu.Item>
  );

  const menu = <Menu>{showMenuItems()}</Menu>;

  return (
    <div style={iconUrl}>
      {category.header_ids && category.header_ids.length ? (
        <Dropdown
          trigger={triggerValue}
          overlay={menu}
          visible={isVisible}
          onVisibleChange={(flag: boolean) => setIsVisible(flag)}
          className="kd-category-dropdown-wrap">
          <Button
            key={category._id}
            className="kd-home-category-item"
            onClick={() => setIsVisible(!isVisible)}>
            <div className="kd-home-category-img">
              <div className="category-icon"></div>
            </div>
            <div className="kd-home-category-name sub-content">
              <span title={category.name}>{category.name}</span>
            </div>
          </Button>
        </Dropdown>
      ) : (
        <Link
          to={getRoute(category.slug, "", false)}
          key={category._id}
          className="kd-home-category-item">
          <div className="kd-home-category-img">
            <div className="category-icon"></div>
          </div>
          <div className="kd-home-category-name sub-content">
            <span title={category.name}>{category.name}</span>
          </div>
        </Link>
      )}
    </div>
  );
};

export default HomeCategoryItem;
